import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const TooltipIcon = React.forwardRef(function TooltipIconRender(props, ref) {
  return <FontAwesomeIcon {...props} ref={ref} />;
});

export default TooltipIcon;
